import { createSlice } from "@reduxjs/toolkit";
import {
  deletePropertyImages,
  EditProperty,
  getPropertyData,
  PostPropertyDocsUpload,
  deletePropertyDocs,
  getPropertyCategoryReference,
  step1CreateProperty,
  UpdateAddProperty,
  uploadImages,
  deleteProperty,
  transferProperty,
  getPublicSingleProperty,
  getPropertyOnlyVideoURLData,
  getPropertyOnlyDocsData,
  getPropertiesMap,
  getPropertiesList,
  getPropertyOnlyImagesData,
  getDocDataofProperty,
  getRiskDataOfProperty,
  getPropertyMasterData,
  uploadProppertyDoc,
  sharePropertyDocument,
  deletePropertyDoccument,
  getLakesAndPonds,
  VerifyRisk,
  getBuyAndRentPropertiesList,
  buyAndRentReference,
  getListedPropertiesList,
  getRentWishList,
  getBuyWishList,
  getNonListedPropertiesList,
  getBuyAndRentPropertiesMap,
  universalSearch,
  getBuyWishlistCoordinates,
  getRentWishlistCoordinates,
  getPropertyMarketValue,
} from "./propertyActions";
import { serviceCheckout } from "../documentService/documentServiceActions";
// import { useEffect } from "react"

const initialState = {
  loading: false,
  getPropertyMarketValueData: null,
  getPropertyMarketValueDataLoading: false,
  getPropertyMarketValueDataError: null,
  listLoading: false,
  mapLoading: false,
  listCount: 0,
  mapCount: 0,
  propertiesCount: 0,
  PropertyReferenes: {
    categoriesList: [],
    documentationList: [],
  },
  addPropertyReference: [],
  mapCenter: {},
  properties: [],
  mapProperties: [],
  buyAndRentMapProperties: [],
  listProperties: [],
  singleProperty: [],

  stepProperty: {},
  error: null,
  message: null,
  success: null,
  makeApiCall: true,
  DummyMarker: { latLng: {}, showDummyMarker: false },
  HoveredPropertyID: "",
  mapInstance: null,
  mode: "",
  EnablePropertyControls: false,
  showGallery: false,
  addPropertyFrom: "",
  singlePropertyMasterData: [],
  singlePropertyDocs: [],
  singlePropertyRisks: [],
  errorMessage: "",
  uploadDocErrorMessage: "",
  shareDocErrorMessage: "",
  deleteDocErrorMessage: "",
  riskDocErrorMessage: "",
  verifyDocumentErrorMsg: "",
  propertyNearBy: {},
  propertyDocuments: [],
  lakesData: {},
  buyandrentForm: [],
  buyPropertiesCount: "",
  selectedLisitingProperty: "",
  listedListProperties: [],
  listedPropertiesListCount: 0,
  buyWishList: [],
  rentWishList: [],
  nonAddedListingProperties: [],
  universalSearchPayload: {
    sortColumn: "requestTime",
    sortDirection: "asc",
    textSearch: "",
  },
  universalSearchSuggestions: [],
  addlistingType: "",
  transferPropertyData: null,
  transferPropertySuccess: false,
  transferPropertyError: null,
  transferPropertyLoading: false,
};

const propertySlice = createSlice({
  name: "propertySlice",
  initialState,
  reducers: {
    clearSingleProperty: (state, action) => {
      state.singleProperty = [];
      state.stepProperty = {};
    },
    clearStepProperty: (state) => {
      state.stepProperty = {};
    },
    setGalleryInRedux: (state, action) => {
      state.showGallery = !state.showGallery;
    },
    setSingleProperty: (state, { payload }) => {
      state.singleProperty = payload;
    },
    clearErrorMessage: (state, action) => {
      state.errorMessage = "";
    },
    changeCenter: (state, action) => {
      state.mapCenter = action.payload;
    },
    propertyControlsHandler: (state, { payload }) => {
      state.EnablePropertyControls = payload;
    },
    makeApicallStatusChange: (state, { payload }) => {
      state.makeApiCall = payload.makeApiCall;
    },
    hoveredIDCHnage: (state, { payload }) => {
      state.HoveredPropertyID = payload;
    },
    mapIstanceChange: (state, { payload }) => {
      state.mapInstance = payload;
    },

    addPropertyFromaddPropertyFrom: (state, { payload }) => {
      state.addPropertyFrom = payload;
    },
    addPropertyFrom: (state, { payload }) => {
      state.addPropertyFrom = payload;
    },
    clearUploadDocErrorMsg: (state, { payload }) => {
      state.uploadDocErrorMessage = "";
    },
    clearshareDocErrorMsg: (state, { payload }) => {
      state.shareDocErrorMessage = "";
    },
    clearDeleteDocErrorMsg: (state, { payload }) => {
      state.deleteDocErrorMessage = "";
    },
    clearRiskErrorMsg: (state, { payload }) => {
      state.riskDocErrorMessage = "";
    },
    clearVerifyDocErrorMsg: (state, { payload }) => {
      state.verifyDocumentErrorMsg = "";
    },
    clearPropertyNearBy: (state, { payload }) => {
      state.propertyNearBy = {};
    },
    setPropertyNearByDataInRedux: (state, { payload }) => {
      state.propertyNearBy = { ...payload };
    },
    setSelectedLisitingProperty: (state, { payload }) => {
      state.selectedLisitingProperty = payload;
    },
    setListProperties: (state, { payload }) => {
      state.listProperties = payload;
      state.listedListProperties = payload;
    },
    setMapProperties: (state, { payload }) => {
      state.mapProperties = payload;
    },

    setWishlistItem: (state, { payload }) => {
      state.listProperties = payload;
    },
    showRentWishList: (state) => {
      state.listProperties = state.rentWishList;
    },
    updateWishList: (state, { payload }) => {
      state.buyWishList = payload;
      state.rentWishList = payload;
    },
    showBuyWihslist: (state) => {
      state.listProperties = state.buyWishList;
    },
    addWishListProperty: (state, { payload }) => {
      state.mapProperties = payload;
    },
    removeWishistPropertyId: (state, { payload }) => {},
    onChangeUniversalSearchPayload: (state, { payload }) => {
      state.universalSearchPayload = payload;
    },
    clearUniversalSearchSuggestion: (state, { payload }) => {
      state.universalSearchSuggestions = [];
    },
    setAddListingType: (state, { payload }) => {
      state.addlistingType = payload;
    },
    filterpropertiesInDrawing: (state, { payload }) => {
      const properties = state.listProperties;
    },
    clearTransferError: (state) => {
      state.transferPropertyError = null;
    },
  },
  extraReducers: (builder) => {
    // get Property Categories Reference List
    builder.addCase(getPropertyCategoryReference.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getPropertyCategoryReference.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.success = payload?.response?.data?.status?.type === "success";
        state.PropertyReferenes.categoriesList =
          payload?.response?.data?.data?.item?.category;
        state.addPropertyReference = payload?.response?.data?.data?.item;
      }
    );
    builder.addCase(
      getPropertyCategoryReference.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = true;
      }
    );

    // step 1 Create a property
    builder.addCase(step1CreateProperty.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(step1CreateProperty.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;
      state.stepProperty = payload?.response?.data?.info;
    });
    builder.addCase(step1CreateProperty.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    // step 2 Update Location
    builder.addCase(UpdateAddProperty.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(UpdateAddProperty.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;
    });
    builder.addCase(UpdateAddProperty.rejected, (state, { payload }) => {
      if (payload?.status == 429) {
        if (state.errorMessage?.length !== "") {
          state.errorMessage = payload?.data?.status?.message;
        }
      }
      state.loading = false;
      state.error = true;
    });

    // upload Property Doucments
    //  builder.addCase(getDocDataofProperty.pending, (state) => {
    //    state.loading = true
    // })
    // builder.addCase(getDocDataofProperty.fulfilled, (state, { payload }) => {

    //    state.loading = false
    //    state.success = payload?.response?.data?.success
    // })
    // builder.addCase(getDocDataofProperty.rejected, (state, { payload }) => {

    //    state.loading = false
    //    state.error = true
    // })

    // step 1 Create a property
    builder.addCase(getLakesAndPonds.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLakesAndPonds.fulfilled, (state, { payload }) => {
      state.lakesData = payload?.response?.data;
    });
    builder.addCase(getLakesAndPonds.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    // upload Property Doucments
    builder.addCase(PostPropertyDocsUpload.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(PostPropertyDocsUpload.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;
    });
    builder.addCase(PostPropertyDocsUpload.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    // sharePropertyDocument Property Doucments
    builder.addCase(sharePropertyDocument.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sharePropertyDocument.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;
    });
    builder.addCase(sharePropertyDocument.rejected, (state, { payload }) => {
      if (payload?.status == 429) {
        if (state.shareDocErrorMessage?.length !== "") {
          state.shareDocErrorMessage = payload?.data?.status?.message;
        }
      }
      state.loading = false;
      state.error = true;
      state.loading = false;
      state.error = true;
    });

    //  verify risks

    builder.addCase(VerifyRisk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(VerifyRisk.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;
    });
    builder.addCase(VerifyRisk.rejected, (state, { payload }) => {
      if (payload?.status == 429) {
        if (state.riskDocErrorMessage?.length !== "") {
          state.riskDocErrorMessage = payload?.data?.status?.message;
        }
      }
      state.loading = false;
      state.error = true;
      state.loading = false;
      state.error = true;
    });

    // verify Document
    // delete property document
    builder.addCase(serviceCheckout.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(serviceCheckout.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;
    });
    builder.addCase(serviceCheckout.rejected, (state, { payload }) => {
      if (payload?.status == 429) {
        if (state.verifyDocumentErrorMsg?.length !== "") {
          state.verifyDocumentErrorMsg = payload?.data?.status?.message;
        }
      }
      state.loading = false;
      state.error = true;
    });

    // delete property document
    builder.addCase(deletePropertyDoccument.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deletePropertyDoccument.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;
    });
    builder.addCase(deletePropertyDoccument.rejected, (state, { payload }) => {
      if (payload?.status == 429) {
        if (state.deleteDocErrorMessage?.length !== "") {
          state.deleteDocErrorMessage = payload?.data?.status?.message;
        }
      }

      state.loading = false;
      state.error = true;
    });

    // Edit Property Details
    builder.addCase(EditProperty.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(EditProperty.fulfilled, (state, { payload }) => {
      state.loading = false;
    });
    builder.addCase(EditProperty.rejected, (state) => {
      state.loading = false;
    });

    // delete property images
    builder.addCase(deletePropertyImages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deletePropertyImages.fulfilled, (state, { payload }) => {
      state.loading = false;
    });
    builder.addCase(deletePropertyImages.rejected, (state) => {
      state.loading = false;
    });

    // upload property Images
    builder.addCase(uploadImages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(uploadImages.fulfilled, (state, { payload }) => {
      state.loading = false;

      const propertyIndex = state.listProperties.findIndex(
        (item) => item?._id === payload?.propertyId
      );
      state.singleProperty = {
        ...state.singleProperty,
        ...payload?.response?.data?.info,
      };
      if (propertyIndex !== -1) {
        state.listProperties[propertyIndex];
        state.listProperties[propertyIndex] = {
          ...state.listProperties[propertyIndex],
          ...payload?.response?.data?.info,
        };
      }
    });
    builder.addCase(uploadImages.rejected, (state) => {
      state.loading = false;
    });

    // get Only Property Docs
    builder.addCase(getPropertyOnlyDocsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPropertyOnlyDocsData.fulfilled, (state, { payload }) => {
      state.loading = false;

      let Docs = [];
      for (let eachDoc in payload?.response?.data?.data?.item?.docs) {
        Docs.push({
          id: eachDoc,
          ...payload?.response?.data?.data?.item?.docs[eachDoc],
        });
      }

      state.singleProperty = {
        ...state.singleProperty,
        docs: payload?.response?.data?.data?.item?.docs,
        documents: payload?.response?.data?.data?.item?.documents,
        propertyScore: payload?.response?.data?.data?.item?.propertyScore,
      };
      // Update propertyScore in listProperties
      state.listProperties = state.listProperties.map((item) =>
        item?._id === payload?.propertyId
          ? {
              ...item,
              propertyScore: payload?.response?.data?.data?.item?.propertyScore,
            }
          : item
      );
    });
    builder.addCase(getPropertyOnlyDocsData.rejected, (state) => {
      state.loading = false;
    });

    // get only property video data
    builder.addCase(getPropertyOnlyVideoURLData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getPropertyOnlyVideoURLData.fulfilled,
      (state, { payload }) => {
        state.loading = false;

        state.singleProperty = {
          ...state.singleProperty,
          videoUrl: payload?.response?.data?.data?.item?.videoUrl,
        };
      }
    );
    builder.addCase(getPropertyOnlyVideoURLData.rejected, (state) => {
      state.loading = false;
    });

    // delete Property
    builder.addCase(deleteProperty.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteProperty.fulfilled, (state, { payload }) => {
      state.loading = false;
      const propertyIdToRemove = payload?.propertyId;
      state.listProperties = state.listProperties.filter(
        (item) => item?._id !== propertyIdToRemove
      );
      state.mapProperties = state.mapProperties.filter(
        (item) => item?._id !== propertyIdToRemove
      );
    });
    builder.addCase(deleteProperty.rejected, (state) => {
      state.loading = false;
    });
    getPropertyMarketValue;
    // get
    builder
      .addCase(getPropertyMarketValue.pending, (state) => {
        state.getPropertyMarketValueData = null;
        state.getPropertyMarketValueDataLoading = true;
        state.getPropertyMarketValueDataError = null;
      })
      .addCase(getPropertyMarketValue.fulfilled, (state, action) => {
        state.getPropertyMarketValueData =
          action.payload?.response?.data || null;
        state.getPropertyMarketValueDataLoading = false;
        state.getPropertyMarketValueDataError = null;
      })
      .addCase(getPropertyMarketValue.rejected, (state, action) => {
        state.getPropertyMarketValueData = null;
        state.getPropertyMarketValueDataLoading = false;
        state.getPropertyMarketValueDataError =
          action.payload || "getPropertyMarketValueDataError failed";
      });

    // get MAP properties
    builder.addCase(getPropertiesMap.pending, (state) => {
      if (state.mapCount === 0) {
        state.mapLoading = true;
      }
      if (state.mapCount < 6) {
        state.mapCount = state.mapCount + 1;
      } else if (state.mapCount === 6) {
        state.mapCount = 0;
      }
    });
    builder.addCase(getPropertiesMap.fulfilled, (state, { payload }) => {
      state.mapLoading = false;
      state.success = payload?.response?.data?.success;
      state.mapProperties = payload?.response?.data?.data?.item?.properties;
    });
    builder.addCase(getPropertiesMap.rejected, (state, { payload }) => {
      state.mapLoading = false;
      state.error = true;
    });

    // get MAP properties
    builder.addCase(getBuyAndRentPropertiesMap.pending, (state) => {
      if (state.mapCount === 0) {
        state.mapLoading = true;
      }
      if (state.mapCount < 6) {
        state.mapCount = state.mapCount + 1;
      } else if (state.mapCount === 6) {
        state.mapCount = 0;
      }
    });
    builder.addCase(
      getBuyAndRentPropertiesMap.fulfilled,
      (state, { payload }) => {
        state.mapLoading = false;
        state.success = payload?.response?.data?.success;
        state.mapProperties = payload?.response?.data?.data?.item?.properties;
        state.buyAndRentMapProperties =
          payload?.response?.data?.data?.item?.properties;
      }
    );
    builder.addCase(
      getBuyAndRentPropertiesMap.rejected,
      (state, { payload }) => {
        state.mapLoading = false;
        state.error = true;
      }
    );

    // get MAP properties

    // getRentWishlistCoordinates

    builder.addCase(getRentWishlistCoordinates.pending, (state) => {
      if (state.mapCount === 0) {
        state.mapLoading = true;
      }
      if (state.mapCount < 6) {
        state.mapCount = state.mapCount + 1;
      } else if (state.mapCount === 6) {
        state.mapCount = 0;
      }
    });
    builder.addCase(
      getRentWishlistCoordinates.fulfilled,
      (state, { payload }) => {
        state.mapLoading = false;
        state.success = payload?.response?.data?.success;
        state.mapProperties = payload?.response?.data?.data?.item?.properties;
        state.buyAndRentMapProperties =
          payload?.response?.data?.data?.item?.properties;
      }
    );
    builder.addCase(
      getRentWishlistCoordinates.rejected,
      (state, { payload }) => {
        state.mapLoading = false;
        state.error = true;
      }
    );

    // getBuyWishlistCoordinates
    builder.addCase(getBuyWishlistCoordinates.pending, (state) => {
      if (state.mapCount === 0) {
        state.mapLoading = true;
      }
      if (state.mapCount < 6) {
        state.mapCount = state.mapCount + 1;
      } else if (state.mapCount === 6) {
        state.mapCount = 0;
      }
    });
    builder.addCase(
      getBuyWishlistCoordinates.fulfilled,
      (state, { payload }) => {
        state.mapLoading = false;
        state.success = payload?.response?.data?.success;
        state.mapProperties = payload?.response?.data?.data?.item?.properties;
        state.buyAndRentMapProperties =
          payload?.response?.data?.data?.item?.properties;
      }
    );
    builder.addCase(
      getBuyWishlistCoordinates.rejected,
      (state, { payload }) => {
        state.mapLoading = false;
        state.error = true;
      }
    );

    // get list properties
    builder.addCase(getPropertiesList.pending, (state) => {
      if (state.listCount === 0) {
        state.listLoading = true;
      }
      if (state.listCount < 6) {
        state.listCount = state.listCount + 1;
      } else if (state.listCount === 6) {
        state.listCount = 0;
      }
    });
    builder.addCase(getPropertiesList.fulfilled, (state, { payload }) => {
      state.listLoading = false;
      state.success = payload?.response?.data?.success;

      state.propertiesCount = payload?.response?.data?.data?.count;
      state.listProperties = payload?.response?.data?.data?.items;
    });
    builder.addCase(getPropertiesList.rejected, (state, { payload }) => {
      state.listLoading = false;
      state.error = true;
    });

    // get Buy and rent properties
    builder.addCase(getBuyAndRentPropertiesList.pending, (state) => {
      if (state.listCount === 0) {
        state.listLoading = true;
      }
      if (state.listCount < 6) {
        state.listCount = state.listCount + 1;
      } else if (state.listCount === 6) {
        state.listCount = 0;
      }
    });
    builder.addCase(
      getBuyAndRentPropertiesList.fulfilled,
      (state, { payload }) => {
        state.listLoading = false;
        state.success = payload?.response?.data?.success;

        // state.propertiesCount = payload?.response?.data?.data?.count

        state.listProperties = payload?.response?.data?.data?.items;
        state.buyPropertiesCount = payload?.response?.data?.data?.count;
        // state.listedListProperties =   payload?.response?.data?.data?.items
      }
    );
    builder.addCase(
      getBuyAndRentPropertiesList.rejected,
      (state, { payload }) => {
        state.listLoading = false;
        state.error = true;
      }
    );

    //   //  getRentWishList
    //   builder.addCase(getRentWishList.pending, (state) => {

    // })
    // builder.addCase(getRentWishList.fulfilled, (state, { payload }) => {
    //    state.listLoading = false
    //    state.success = payload?.response?.data?.success

    // state.rentWishList = payload?.response?.data?.data?.items
    //    // state.listedListProperties =   payload?.response?.data?.data?.items

    // })
    // builder.addCase(getRentWishList.rejected, (state, { payload }) => {

    //    state.listLoading = false
    //    state.error = true
    // })

    //  getBuyWishList
    builder.addCase(getBuyWishList.pending, (state) => {
      // state.listLoading = true
    });
    builder.addCase(getBuyWishList.fulfilled, (state, { payload }) => {
      //   state.listLoading = false
      state.success = payload?.response?.data?.success;

      state.buyWishList = payload?.response?.data?.data?.items;
      //   state.listProperties =   payload?.response?.data?.data?.items
    });
    builder.addCase(getBuyWishList.rejected, (state, { payload }) => {
      //   state.listLoading = false
      state.error = true;
    });

    //  getRentWishList
    builder.addCase(getRentWishList.pending, (state) => {});
    builder.addCase(getRentWishList.fulfilled, (state, { payload }) => {
      //   state.listLoading = false
      state.success = payload?.response?.data?.success;

      state.rentWishList = payload?.response?.data?.data?.items;
      // state.listProperties =   payload?.response?.data?.data?.items
    });
    builder.addCase(getRentWishList.rejected, (state, { payload }) => {
      state.listLoading = false;
      state.error = true;
    });

    // get nonAddedListingProperties
    builder.addCase(getNonListedPropertiesList.pending, (state) => {});
    builder.addCase(
      getNonListedPropertiesList.fulfilled,
      (state, { payload }) => {
        state.listLoading = false;
        state.success = payload?.response?.data?.success;
        state.nonAddedListingProperties = payload?.response?.data?.data?.items;

        //  state.buyWishList = payload?.response?.data?.data?.items
        // state.listedListProperties =   payload?.response?.data?.data?.items
      }
    );
    builder.addCase(
      getNonListedPropertiesList.rejected,
      (state, { payload }) => {
        state.listLoading = false;
        state.error = true;
      }
    );

    // get Buy and rent properties
    builder.addCase(getListedPropertiesList.pending, (state) => {
      if (state.listCount === 0) {
        state.listLoading = true;
      }
      if (state.listCount < 6) {
        state.listCount = state.listCount + 1;
      } else if (state.listCount === 6) {
        state.listCount = 0;
      }
    });
    builder.addCase(getListedPropertiesList.fulfilled, (state, { payload }) => {
      state.listLoading = false;
      state.success = payload?.response?.data?.success;

      // state.propertiesCount = payload?.response?.data?.data?.count

      // state.listProperties = payload?.response?.data?.data?.items
      state.listedPropertiesListCount = payload?.response?.data?.data?.count;
      state.listedListProperties = payload?.response?.data?.data?.items;
    });
    builder.addCase(getListedPropertiesList.rejected, (state, { payload }) => {
      state.listLoading = false;
      state.error = true;
    });

    //get property Risks Data

    //  single PropertyDocuments

    builder.addCase(universalSearch.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(universalSearch.fulfilled, (state, { payload }) => {
      state.universalSearchSuggestions = payload?.response.data?.data?.items;
    });

    builder.addCase(universalSearch.rejected, (state, { payload }) => {
      state.loading = false;
    });

    // get private Property Data
    builder.addCase(getPropertyData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPropertyData.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;

      if (payload?.response?.data?.data?.item) {
        state.stepProperty = payload?.response?.data?.data?.item;
      }

      state.singleProperty = payload?.response?.data?.data?.item;
      const propertyIndex = state.listProperties.findIndex(
        (item) => item?._id === payload?.id
      );
      // if (propertyIndex !== -1) {
      //    // state.listProperties[propertyIndex] = {
      //    //    ...payload?.response?.data?.data?.item
      //    // };
      // }
    });
    builder.addCase(getPropertyData.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    // get Public Single Properties
    builder.addCase(getPublicSingleProperty.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPublicSingleProperty.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = payload?.response?.data?.success;
      state.stepProperty = payload?.response?.data?.data?.item;
      state.singleProperty = payload?.response?.data?.data?.item;
    });
    builder.addCase(getPublicSingleProperty.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    // get Property Images
    builder.addCase(getPropertyOnlyImagesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getPropertyOnlyImagesData.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        const propertyIndex = state.listProperties.findIndex(
          (item) => item?._id === payload?.propertyId
        );
        if (propertyIndex !== -1) {
          state.listProperties[propertyIndex];
          state.listProperties[propertyIndex] = {
            ...state.listProperties[propertyIndex],
            images: payload?.response?.data?.data?.item?.images,
          };
        }
        state.singleProperty = {
          ...state.singleProperty,
          images: payload?.response?.data?.data?.item?.images,
        };
      }
    );
    builder.addCase(getPropertyOnlyImagesData.rejected, (state) => {
      state.loading = false;
    });

    //  single PropertyDocuments

    //  builder.addCase(getDocDataofProperty.pending, (state) => {
    //    state.loading = true;
    //  });
    builder
      .addCase(getDocDataofProperty.pending, (state) => {
        state.isDocsLoading = true;
        state.singlePropertyDocs = []; // clear old docs
      })
      .addCase(getDocDataofProperty.fulfilled, (state, { payload }) => {
        state.isDocsLoading = false;
        state.singlePropertyDocs = payload?.response?.data?.docs || [];
      })
      .addCase(getDocDataofProperty.rejected, (state) => {
        state.isDocsLoading = false;
        state.singlePropertyDocs = [];
      });

    // builder.addCase(
    //    getDocDataofProperty.fulfilled,
    //    (state, { payload }) => {
    //       state.singlePropertyDocs = payload?.response?.data?.docs;
    //    }
    // );

    // builder.addCase(getDocDataofProperty.rejected, (state, { payload }) => {
    //    state.loading = false;
    // });

    //get property Risks Data

    //  single PropertyDocuments

    builder.addCase(getRiskDataOfProperty.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getRiskDataOfProperty.fulfilled, (state, { payload }) => {
      state.singlePropertyRisks = payload?.response?.data?.risks;
    });

    builder.addCase(getRiskDataOfProperty.rejected, (state, { payload }) => {
      state.loading = false;
    });

    // buyAndRentReference

    builder.addCase(buyAndRentReference.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buyAndRentReference.fulfilled, (state, { payload }) => {
      state.loading = false;

      state.buyandrentForm = payload?.response?.data;
    });
    builder.addCase(buyAndRentReference.rejected, (state) => {
      state.loading = false;
    });

    // get PropertyMasterData
    builder.addCase(getPropertyMasterData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPropertyMasterData.fulfilled, (state, { payload }) => {
      state.loading = false;

      let dummyData = [payload?.response?.data?.fields];
      let stateData = {
        id: "STATE_NAME",
        name: "State",
        type: "state",
        required: true,
      };

      const left = dummyData.splice(0, 2);

      left.push(stateData);
      const lastIndex = dummyData?.length;
      let right = dummyData.splice(0, lastIndex);

      let totalNewData = [...left, ...right];

      if (totalNewData?.length > 2) {
        state.singlePropertyMasterData = payload?.response?.data?.fields;
      }
    });
    builder.addCase(getPropertyMasterData.rejected, (state) => {
      state.loading = false;
    });

    // transfer Property
    builder
      .addCase(transferProperty.pending, (state) => {
        state.transferPropertyData = null;
        state.transferPropertySuccess = false;
        state.transferPropertyError = null;
        state.transferPropertyLoading = true;
      })
      .addCase(transferProperty.fulfilled, (state, action) => {
        state.transferPropertyData = action.payload?.response || null;
        state.transferPropertySuccess = true;
        state.transferPropertyError = null;
        state.transferPropertyLoading = false;
      })
      .addCase(transferProperty.rejected, (state, action) => {
        state.transferPropertyData = null;
        state.transferPropertySuccess = false;
        state.transferPropertyLoading = false;
        state.transferPropertyError =
          action.payload || "Transfer Property failed";
      });
  },
});

export default propertySlice.reducer;

export const {
  clearStepProperty,
  setPropertyNearByDataInRedux,
  clearPropertyNearBy,
  clearDeleteDocErrorMsg,
  clearshareDocErrorMsg,
  clearErrorMessage,
  clearUploadDocErrorMsg,
  clearVerifyDocErrorMsg,
  setGalleryInRedux,
  clearRiskErrorMsg,
  propertyControlsHandler,
  hoveredIDCHnage,
  mapIstanceChange,
  setWishlistItem,
  makeApicallStatusChange,
  updateSelctedDocs,
  changeCenter,
  clearSingleProperty,
  addPropertyFrom,
  addPropertyFromaddPropertyFrom,
  setSelectedLisitingProperty,
  showRentWishList,
  showBuyWihslist,
  addWishListProperty,
  clearUniversalSearchSuggestion,
  onChangeUniversalSearchPayload,
  setAddListingType,
  clearTransferError,
  setSingleProperty,
  setListProperties,
  setMapProperties,
  filterpropertiesInDrawing,
  updateWishList,
} = propertySlice.actions;
